/**
 * @generated SignedSource<<05665386be50d2b090065cb5af5899bd>>
 * @relayHash 0d7b1475410551327bfc1ee56682f4cf
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d7b1475410551327bfc1ee56682f4cf

import type { ConcreteRequest } from 'relay-runtime';
export type IssuePlanBodyQuery$variables = {
  id: string;
};
export type IssuePlanBodyQuery$data = {
  readonly node: {
    readonly planBody?: string | null | undefined;
    readonly planBodyHTML?: string | null | undefined;
  } | null | undefined;
};
export type IssuePlanBodyQuery = {
  response: IssuePlanBodyQuery$data;
  variables: IssuePlanBodyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planBodyHTML",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssuePlanBodyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssuePlanBodyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0d7b1475410551327bfc1ee56682f4cf",
    "metadata": {},
    "name": "IssuePlanBodyQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b7cf6bcb826bca414ee0ed19102d8ff1";

export default node;
